module.exports = __webpack_public_path__ + "static/media/banner_mobile.0590b3eb.jpg";